import httpClient from '@/http-client'
export const get = (Options = {}) => {
  return httpClient
    .get('/api/health-items', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const store = data => {
  return httpClient
    .post('/api/health-items', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const update = data => {
  return httpClient
    .put(`/api/health-items/${data.health_item_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const destroy = id => {
  return httpClient
    .delete(`/api/health-items/${id}`)
    .then(response => Promise.resolve(response.data))
}

export const category = (health_category_id, Options = {}) => {
  return httpClient
    .get(`/api/health-items/${health_category_id}/categories`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  store,
  get,
  update,
  destroy,
  category
}
